import WhatsLogo from "../../../../../assets/whatsapp-logo.svg"
import {WhatsappButton, WhatsappForm} from "./styles";

const WhatsappBtn = () => {
    return (
        <WhatsappForm
            href="https://wa.me/5511981669461?text=Ol%C3%A1!%20Gostaria%20de%20resolver%20minhas%20pend%C3%AAncias%20com%20a%20Fix%20it."
            target="_blank"
            rel="noopener noreferrer"
        >
            <WhatsappButton type="button">
                <img src={WhatsLogo} alt="Logo Whatsapp"/>SAF Fix It
            </WhatsappButton>
        </WhatsappForm>
    );
}

export default WhatsappBtn;